import { render, staticRenderFns } from "./GMBMenu.vue?vue&type=template&id=c7fd149e&scoped=true"
import script from "./GMBMenu.vue?vue&type=script&lang=js"
export * from "./GMBMenu.vue?vue&type=script&lang=js"
import style0 from "./GMBMenu.vue?vue&type=style&index=0&id=c7fd149e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fd149e",
  null
  
)

export default component.exports